import { initializeGlobalClickEvent } from '../core/global-event-handlers';
import { initializeGlobalFetchWrapper } from './fetch.js';

initializeGlobalClickEvent();
initializeGlobalFetchWrapper();
